import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../Context/UserContextProvider';

import styles from "../DashboardFileManagement/DashboardFileManagement.module.css"
import axios from 'axios';

export default function FileTotalInfo({ cardDetailData, limit, notify, limitConsultant }) {
    const { permissions } = useContext(UserContext);
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    const allowPermission = [19, 18, 17, 15]

    function haveCommonElements(arr1, arr2) {
        return arr1.some(item => arr2.includes(item));
    }

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        axios.get("Category").then((res) => {
            setCategories(res.data.data);
        });
    }, []);

    return (
        <>
            <div className={`w-100 d-flex align-items-center justify-content-centeer flex-wrap mt-3 mb-2 px-3 ${styles.card_main_detail_container}`}>
                <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-start flex-wrap px-2'>
                    <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                        <div className={styles.card_main_detail_text1}>
                            شناسه فایل:
                        </div>
                        <div className={`pointer ${styles.file_code}`} onClick={() => handleCopyClick(cardDetailData?.fileCode?.match(/\d+/)[0])}>
                            {cardDetailData?.fileCode?.match(/\d+/)[0]}
                        </div>
                    </div>

                    <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                        <div className={styles.card_main_detail_text1}>
                            دسته‌بندی:
                        </div>
                        <div className={styles.card_main_detail_text2}>
                            {cardDetailData?.categoryTitle}
                        </div>
                    </div>

                    <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                        <div className={styles.card_main_detail_text1}>
                            نوع فایل:
                        </div>
                        <div className={styles.card_main_detail_text2}>
                            {cardDetailData?.subCategoryTitle}
                        </div>
                    </div>
                </div>
                {categories?.find((c) => c.id == cardDetailData.categoryId)?.dealType != 1 ?
                    <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-start flex-wrap px-2'>
                        {limit?.find((item) => item === "TotalPrice") ?
                            <></>
                            : <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                                <div className={styles.card_main_detail_text1}>
                                    قیمت کل:
                                </div>
                                <div className="d-flex align-items-center justify-content-center">
                                    <div className={styles.card_main_price}>
                                        {e2p(cardDetailData?.totalPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}
                                    </div>
                                    <span className={`me-1 ${styles.card_main_detail_text2}`}>
                                        تومان
                                    </span>
                                </div>
                            </div>}
                        {limit?.find((item) => item === "MeteragePrice") ?
                            <></>
                            : <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                                <div className={styles.card_main_detail_text1}>
                                    قیمت هر متر:
                                </div>
                                <div className={styles.card_main_detail_text2}>
                                    {e2p(cardDetailData?.meteragePrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}  تومان هر متر مربع
                                </div>
                            </div>}
                        <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                            <div className={styles.card_main_detail_text1}>
                                تاریخ آپلود:
                            </div>
                            <div className={styles.card_main_detail_text2}>
                                {e2p(cardDetailData?.createDate?.toString())}
                            </div>
                        </div>
                    </div>
                    :
                    <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap px-2'>
                        {limit?.find((item) => item === "MortgagePrice") ?
                            <></>
                            : <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                                <div className={styles.card_main_detail_text1}>
                                    رهن:
                                </div>
                                <div className="d-flex align-items-center justify-content-center">
                                    <div className={styles.card_main_price}>
                                        {e2p(cardDetailData?.mortgagePrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}
                                    </div>
                                    <span className={`me-1 ${styles.card_main_detail_text2}`}>
                                        تومان
                                    </span>
                                </div>
                            </div>}
                        {limit?.find((item) => item === "RentPrice") ?
                            <></>
                            : <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                                <div className={styles.card_main_detail_text1}>
                                    اجاره ماهانه:
                                </div>
                                <div className={styles.card_main_price}>
                                    {e2p(cardDetailData?.rentPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}
                                </div>
                                <span className={`me-1 ${styles.card_main_detail_text2}`}>
                                    تومان
                                </span>
                            </div>}
                        <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                            <div className={styles.card_main_detail_text1}>
                                تاریخ آپلود:
                            </div>
                            <div className={styles.card_main_detail_text2}>
                                {e2p(cardDetailData?.createDate?.toString())}
                            </div>
                        </div>
                    </div>

                }

                {/* <div className='w-75 d-flex align-items-center gap-5'> */}
                <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                    <div className={styles.card_main_detail_text1}>
                        تعداد واحد در هر طبقه :
                    </div>
                    <div className={styles.card_main_detail_text2}>
                        {e2p(cardDetailData?.unitsNumber ? cardDetailData?.unitsNumber?.toString() : 0)}
                    </div>
                </div>

                {/* <div className='d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2'>
                        <div className={styles.card_main_detail_text1}>
                            منطقه جغرافیایی :
                        </div>
                        <div className={styles.card_main_detail_text2}>
                            {cardDetailData?.estateRegion == "1" ? "ایران" : cardDetailData?.estateRegion == "2" ? "ترکیه" : cardDetailData?.estateRegion == "3" && "قبرس" }
                        </div>
                    </div> */}
                {/* </div> */}


                {permissions.find((item) => item == 15) === 15 || (haveCommonElements(permissions, [16, 18]) && !(limitConsultant?.find((item) => item === "FullAddress") === "FullAddress" || limit?.find((item) => item === "FullAddress") === "FullAddress")) ?
                    <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap px-2'>
                        <div className='d-flex align-items-center justify-content-md-start justify-content-start mt-3 mb-3 w-100 flex-wrap'>
                            <div className={`mb-md-0 mb-2 ${styles.card_main_detail_text1}`}>
                                آدرس کامل:
                            </div>
                            <div className={styles.card_main_detail_text2}>
                                {e2p(cardDetailData?.address.fullAddress)}
                            </div>
                        </div>
                    </div> : <></>
                }

                {permissions.find((item) => item == 15) === 15 || (haveCommonElements(permissions, [16, 18]) && !(limitConsultant?.find((item) => item == "ShortAddress") || limit?.find((item) => item == "ShortAddress"))) ?
                    <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap px-2'>
                        <div className='d-flex align-items-center justify-content-md-start justify-content-start mt-3 mb-3 w-100 flex-wrap'>
                            <div className={styles.card_main_detail_text1}>
                                آدرس حدودی:
                            </div>
                            <div className={styles.card_main_detail_text2}>
                                {e2p(cardDetailData?.address?.shortAddress)}
                            </div>
                        </div>
                    </div> : <></>
                    }

            </div >
        </>
    )

    function handleCopyClick(number) {
        navigator.clipboard.writeText(number);
        notify("کد فایل کپی شد", "success")
    };
}
